/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostAzureMaccCommitmentBurndownConfiguration extends models.BaseChartWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("CostAzureMaccCommitmentBurndownConfiguration");
    }

    getFixupPrototypeFunction() { return CostAzureMaccCommitmentBurndownConfiguration.fixupPrototype; }

    static newInstance(model: Partial<CostAzureMaccCommitmentBurndownConfiguration>): CostAzureMaccCommitmentBurndownConfiguration {
        let obj = Object.assign(new CostAzureMaccCommitmentBurndownConfiguration(), model);
        CostAzureMaccCommitmentBurndownConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostAzureMaccCommitmentBurndownConfiguration>): CostAzureMaccCommitmentBurndownConfiguration {
        if (!model) return null;
        return CostAzureMaccCommitmentBurndownConfiguration.newInstance(<CostAzureMaccCommitmentBurndownConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostAzureMaccCommitmentBurndownConfiguration) {
        if (!obj) return;

        models.CostAzureMaccCommitmentBurndownConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostAzureMaccCommitmentBurndownConfiguration): boolean {
        if (models.BaseChartWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CostAzureMaccCommitmentBurndownConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
